/**
 * Today dashboard "Texts & calls" tile visibility + copy.
 * Owner-only; hidden when the workspace has no sms_numbers doc or it's externallyManaged.
 */

import { AUTO_RECHARGE_BILLING_HREF } from './walletAutoRecharge';

export const TEXTS_CALLS_HREF = '/text-messaging';
export const WALLET_HREF = AUTO_RECHARGE_BILLING_HREF;
export const LOW_BALANCE_USD = 5;

export function shouldShowTextsCallsTile({ isOwner = false, smsNumber = null } = {}) {
  return isOwner === true && smsNumber != null && smsNumber.externallyManaged !== true;
}

export function formatTextsCallsTile({
  smsNumber = null,
  activity = {},
  wallet = null,
} = {}) {
  const sent = smsNumber?.segmentsSentToday ?? 0;
  const cap = smsNumber?.dailySegmentCap ?? 0;
  const balanceUsd = typeof wallet?.balanceUsd === 'number' ? wallet.balanceUsd : null;
  const autoOn = wallet?.autoRecharge?.enabled === true;
  return {
    textsLabel: 'Texts sent today',
    textsValue: cap > 0 ? `${sent} / ${cap}` : String(sent),
    missedLabel: 'Missed calls texted back',
    missedSub: 'Last 24 hours',
    missedValue: activity.missedCallsTextedBack24h ?? 0,
    optedOutLabel: 'Opted-out numbers',
    optedOutValue: activity.optedOutNumbers ?? 0,
    walletLabel: 'Wallet',
    walletValue: balanceUsd == null ? '—' : `$${balanceUsd.toFixed(2)}`,
    lowBalance: balanceUsd != null && balanceUsd < LOW_BALANCE_USD,
    lowBalanceLabel: 'Low — top up',
    autoRechargeOn: autoOn,
    autoRechargeLabel: autoOn ? 'Auto-recharge on' : 'Auto-recharge off',
    textsHref: TEXTS_CALLS_HREF,
    walletHref: WALLET_HREF,
  };
}
